import { render, staticRenderFns } from "./SMenuOptListView.vue?vue&type=template&id=ec725bac"
import script from "./SMenuOptListView.vue?vue&type=script&lang=js"
export * from "./SMenuOptListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports